var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-delete_white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete_white",
    clipPath: "url(#clip-delete_white)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9918",
    "data-name": "Group 9918",
    transform: "translate(2 1.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7950",
    "data-name": "Group 7950",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "delete_3_",
    "data-name": "delete (3)",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7945",
    "data-name": "Group 7945",
    transform: "translate(1.653 3.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7944",
    "data-name": "Group 7944"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18604",
    "data-name": "Path 18604",
    d: "M74.142,98.512,73.03,110.371H64.875L63.763,98.512l-1.409.116L63.486,110.7a1.164,1.164,0,0,0,1.175.993h8.582a1.166,1.166,0,0,0,1.176-1l1.132-12.066Z",
    transform: "translate(-62.354 -98.512)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7947",
    "data-name": "Group 7947",
    transform: "translate(4.48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7946",
    "data-name": "Group 7946"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18605",
    "data-name": "Path 18605",
    d: "M151.663,0h-5.187A1.18,1.18,0,0,0,145.3,1.179v2.24h1.415v-2h4.715v2h1.415V1.179A1.18,1.18,0,0,0,151.663,0Z",
    transform: "translate(-145.297)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7949",
    "data-name": "Group 7949",
    transform: "translate(0 2.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7948",
    "data-name": "Group 7948"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18606",
    "data-name": "Path 18606",
    d: "M29.635,79.568H14.545a.707.707,0,1,0,0,1.415H29.635a.707.707,0,1,0,0-1.415Z",
    transform: "translate(-13.838 -79.568)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24469",
    "data-name": "Rectangle 24469",
    width: 4.806,
    height: 1.442,
    rx: 0.721,
    transform: "translate(5.546 8.363)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWhite);
export default __webpack_public_path__ + "static/media/delete_white.b3a58d2d798a4d2dc5fe853446c9f6f3.svg";
export { ForwardRef as ReactComponent };